import {
    TOGGLE_EXPRESS_CHECKOUT,
    DISPLAY_EXPRESS_CHECKOUT,
} from '../actionTypes/ExpressCheckoutActionTypes';

export default function ExpressCheckoutReducer(state = {}, action) {
    // NOSONAR
    switch (
        action.type // NOSONAR
    ) {
        case TOGGLE_EXPRESS_CHECKOUT: {
            const newState = { ...state, ...action.payload };
            newState.enableExpressCheckout = state.enableExpressCheckout
                ? !state.enableExpressCheckout
                : true;
            return newState;
        }
        case DISPLAY_EXPRESS_CHECKOUT: {
            return {
                ...state,
                ...action.payload,
            };
        }
        default:
            return state;
    }
}
